import { urlWithParams } from '@marketplace-web/browser/url-util'

export const USER_PERSONALIZATION_SIZES_URL = '/member/personalization/sizes'
export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const PROFILE_SETTINGS_URL = '/settings/profile'
export const DONATIONS_SETTINGS_URL = '/settings/donations'
export const ROOT_URL = '/'
export const GO_TO_WALLET_URL = '/wallet/balance'
export const MY_ORDERS_URL = '/my_orders'
export const REFERRALS_URL = '/referrals'
export const WALLET_INVOICES_URL = '/wallet/invoices'
export const ITEM_UPLOAD_URL = '/items/new'
export const HELP_FAQ_ENTRIES_URL = '/help'
export const APP_LANDING_URL = '/app'
export const BUSINESS_ACCOUNTS_GUIDE_URL = '/pro-guide'
export const BUSINESS_ACCOUNTS_HOMEPAGE = '/pro'
export const HELP_CENTER_URL = '/help'
export const HOW_IT_WORKS_URL = '/how_it_works'
export const INFOBOARD_URL = '/infoboard'
export const ITEM_VERIFICATION_URL = '/item_verification'
export const ADVERTISING_URL = '/advertising'
export const JOBS_URL_NEW = 'https://careers.vinted.com/'
export const JOBS_URL = '/jobs'
export const ACCESSIBILITY_URL = '/accessibility'
export const MAIN_NAVIGATION_ABOUT_TAB_URL = '/about'
export const TERMS_URL = '/terms_and_conditions'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
export const BUSINESS_TERMS_URL = '/pro-terms-of-use'
export const COOKIE_POLICY_URL = '/cookie-policy'
export const HELP_SAFETY_URL = '/safety'
export const PRIVACY_POLICY_URL = '/privacy-policy'
